export const CONVERSATIONS_ENDPOINT = Object.freeze({
    SEND_MESSAGE: '/conversations/sendMessage',
    SEND_TEMPLATE: '/conversations/sendTemplate',
    LEAD_CONVERSATION: '/conversations/lead',
} as const);

/** Backend (`WarboxConversation`) error codes the clients react to. */
export const CONVERSATIONS_API_ERROR = Object.freeze({
    SESSION_MESSAGE_REQUIRES_INBOUND: 'Errors.SessionMessageRequiresInbound',
    NO_ACTIVE_CONVERSATION_CHANNEL: 'Errors.NoActiveConversationChannel',
    TOKEN_EXPIRED: 'Errors.TokenExpired',
} as const);
